import "./About.css";
import siteData from "../data/siteData.json";

export default function About() {
  const about = siteData.about;

  return (
    <section id="about" className="about-section">
      <div className="container">
        <div className="about-row">

          {/* LEFT IMAGE WITH OVERLAY */}
          <div className="about-img-box">
            <img src={about.image} alt="About" className="about-img" />

            <div className="overlay-text">
              {about.overlayText}
            </div>
          </div>

          {/* RIGHT TEXT CONTENT */}
          <div className="about-content">
            <h3 className="section-label">ABOUT US</h3>
            <h2 className="title">{about.title}</h2>
            <p className="desc">{about.description1}</p>
            <p className="desc">{about.description2}</p>
          </div>

        </div>
      </div>
    </section>
  );
}
